import { BusinessGetResponseType } from "@sellar-io/api-v2/types";

import { type DeepKeys } from "@tanstack/react-form";

import { BusinessFormFieldValues } from "../business/BusinessFormValues";

export type BusinessFieldName = DeepKeys<BusinessFormFieldValues>;

export type SupplierFieldValues = {
  urlId: string;
  transactionFee: number;
  vatPercentage: number | "";
  stripeAccountId: string;
  stripeCustomerId: string;
  imageUrl: string;
};

export const fieldName = (name: string) => name as BusinessFieldName;

export const generateSupplierFieldValues = (
  supplier?: BusinessGetResponseType["Supplier"],
): SupplierFieldValues => ({
  urlId: supplier?.urlId ?? "",
  transactionFee: supplier?.transactionFee ? supplier.transactionFee : 0,
  vatPercentage: supplier?.vatPercentage ? supplier.vatPercentage : 0,
  stripeAccountId: supplier?.stripeAccountId ?? "",
  stripeCustomerId: supplier?.stripeCustomerId ?? "",
  imageUrl: supplier?.imageUrl ?? "",
});
